<strong class="text-lg font-semibold mt-6 pt-2 ml-3 mr-3 border-box">{{ images[(selectedIndex || 0)]?.name }}</strong>

<div class="flex flex-col items-center p-rel mt-2 mb-2 border-box">
  <div class="gallery-navigator left" (click)="showPrevious()">
    @if (hasPrevious) {
      <i class="fa-regular fa-chevron-left fa-2x icon"></i>
    }
  </div>

  <div class="image-container">
    <img [attr.src]="selectedImageURL"  alt="currently selected image"/>
  </div>

  <div class="gallery-navigator right" (click)="showNext()">
    @if (hasNext) {
      <i class="fa-regular fa-chevron-right fa-2x icon"></i>
    }
  </div>

  <div class="flex flex-row p-abs center gallery-stepper-container">
    <div class="gallery-stepper">
      @for (image of images; track image; let i = $index) {
        <div
          class="gallery-indicator"
          [class.active]="selectedIndex === i"
        (click)="selectedIndex = i"></div>
      }
    </div>
  </div>
</div>
